import type { ComponentType, ReactNode } from 'react';
import { cn } from '@/utils/cn';

/**
 * The "nothing here" block. One component for no-data, no-results and
 * error-ish empty screens so they never drift apart visually.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ComponentType<{ className?: string }>;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 py-16 text-center',
        className,
      )}
    >
      {Icon && (
        <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-neutral-100">
          <Icon className="size-6 text-muted" />
        </div>
      )}
      <h3 className="text-h3 text-foreground">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-body text-muted">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
